import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EcoMasterIcon } from '../../../assets/icons';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';
import { getPendingRepresentativesRequest } from '../../actions/certificationActions';

const TobeRepresentativeList = ({ history }) => {
    const dispatch = useDispatch();

    const { listRepresentativeRequest } = useSelector((state) => state.certificationAdmin);

    useEffect(() => {
        dispatch(getPendingRepresentativesRequest())
    }, [])

    return (
        <div className='container-page scroll-menu'>
            <TitleSVG Icon={EcoMasterIcon}
                titleHighlight={'Lista'}
                title={' de solicitudes de ser Ecomaster'}
            />
            <div className='d-flex centerContent mt-5'>
                {(listRepresentativeRequest?.length != 0) ?
                    <div className='wrapper-5 column-gap row-gap container-width'>
                    {listRepresentativeRequest.map((listRepresentativeRequest) => (
                        <div key={listRepresentativeRequest._id} className="card-admin-padding card-admin">
                            <div className="tittle-card-admin center-text">{listRepresentativeRequest.userID.name}</div>
                            <div className="tittle-card-admin center-text mb-1">{listRepresentativeRequest.userID.lastname}</div>
                            <div className="text-content-card center-text">{listRepresentativeRequest.state ===0 ? "Pendiente" : ""}</div>
                            <div className="btns-admin ml-2 mr-2 mt-3"
                                onClick={() => { history.push("./CertificateRepresentativeRequest/" + listRepresentativeRequest._id) }}
                            >Ver Información</div>
                        </div>
                        ))}

                    </div> :
                    <div className='color-purple-dark text-fz-1-5 container-width '> {'No hay Solicitudes pendientes'}</div>
                }
            </div>
        </div>
    )
}

export default TobeRepresentativeList
